// Email Invite Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

// Action Types
export const PREVIEW_EMAIL_UPLOAD = 'PREVIEW_EMAIL_UPLOAD';
export const PREVIEW_EMAIL_UPLOAD_SUCCESS = 'PREVIEW_EMAIL_UPLOAD_SUCCESS';
export const PREVIEW_EMAIL_UPLOAD_FAIL = 'PREVIEW_EMAIL_UPLOAD_FAIL';
export const PREVIEW_EMAIL_UPLOAD_RESET = 'PREVIEW_EMAIL_UPLOAD_RESET';

export const CONFIRM_EMAIL_UPLOAD = 'CONFIRM_EMAIL_UPLOAD';
export const CONFIRM_EMAIL_UPLOAD_SUCCESS = 'CONFIRM_EMAIL_UPLOAD_SUCCESS';
export const CONFIRM_EMAIL_UPLOAD_FAIL = 'CONFIRM_EMAIL_UPLOAD_FAIL';
export const CONFIRM_EMAIL_UPLOAD_RESET = 'CONFIRM_EMAIL_UPLOAD_RESET';

export const GET_EMAIL_INVITES = 'GET_EMAIL_INVITES';
export const GET_EMAIL_INVITES_SUCCESS = 'GET_EMAIL_INVITES_SUCCESS';
export const GET_EMAIL_INVITES_FAIL = 'GET_EMAIL_INVITES_FAIL';
export const GET_EMAIL_INVITES_RESET = 'GET_EMAIL_INVITES_RESET';

export const GET_EMAIL_INVITE_STATS = 'GET_EMAIL_INVITE_STATS';
export const GET_EMAIL_INVITE_STATS_SUCCESS = 'GET_EMAIL_INVITE_STATS_SUCCESS';
export const GET_EMAIL_INVITE_STATS_FAIL = 'GET_EMAIL_INVITE_STATS_FAIL';
export const GET_EMAIL_INVITE_STATS_RESET = 'GET_EMAIL_INVITE_STATS_RESET';

export const GET_EMAIL_BATCHES = 'GET_EMAIL_BATCHES';
export const GET_EMAIL_BATCHES_SUCCESS = 'GET_EMAIL_BATCHES_SUCCESS';
export const GET_EMAIL_BATCHES_FAIL = 'GET_EMAIL_BATCHES_FAIL';
export const GET_EMAIL_BATCHES_RESET = 'GET_EMAIL_BATCHES_RESET';

export const RESEND_EMAIL = 'RESEND_EMAIL';
export const RESEND_EMAIL_SUCCESS = 'RESEND_EMAIL_SUCCESS';
export const RESEND_EMAIL_FAIL = 'RESEND_EMAIL_FAIL';
export const RESEND_EMAIL_RESET = 'RESEND_EMAIL_RESET';

export const RESEND_FAILED_EMAILS = 'RESEND_FAILED_EMAILS';
export const RESEND_FAILED_EMAILS_SUCCESS = 'RESEND_FAILED_EMAILS_SUCCESS';
export const RESEND_FAILED_EMAILS_FAIL = 'RESEND_FAILED_EMAILS_FAIL';
export const RESEND_FAILED_EMAILS_RESET = 'RESEND_FAILED_EMAILS_RESET';

export const BULK_RESEND_EMAILS = 'BULK_RESEND_EMAILS';
export const BULK_RESEND_EMAILS_SUCCESS = 'BULK_RESEND_EMAILS_SUCCESS';
export const BULK_RESEND_EMAILS_FAIL = 'BULK_RESEND_EMAILS_FAIL';
export const BULK_RESEND_EMAILS_RESET = 'BULK_RESEND_EMAILS_RESET';

export const DELETE_PARTICIPANT = 'DELETE_PARTICIPANT';
export const DELETE_PARTICIPANT_SUCCESS = 'DELETE_PARTICIPANT_SUCCESS';
export const DELETE_PARTICIPANT_FAIL = 'DELETE_PARTICIPANT_FAIL';
export const DELETE_PARTICIPANT_RESET = 'DELETE_PARTICIPANT_RESET';

// Reset Actions
export const previewEmailUploadReset = () => ({
  type: PREVIEW_EMAIL_UPLOAD_RESET,
});

export const confirmEmailUploadReset = () => ({
  type: CONFIRM_EMAIL_UPLOAD_RESET,
});

export const getEmailInvitesReset = () => ({
  type: GET_EMAIL_INVITES_RESET,
});

export const getEmailInviteStatsReset = () => ({
  type: GET_EMAIL_INVITE_STATS_RESET,
});

export const getEmailBatchesReset = () => ({
  type: GET_EMAIL_BATCHES_RESET,
});

export const resendEmailReset = () => ({
  type: RESEND_EMAIL_RESET,
});

export const resendFailedEmailsReset = () => ({
  type: RESEND_FAILED_EMAILS_RESET,
});

export const bulkResendEmailsReset = () => ({
  type: BULK_RESEND_EMAILS_RESET,
});

export const deleteParticipantReset = () => ({
  type: DELETE_PARTICIPANT_RESET,
});

// Thunk Actions

// Preview Upload - Validate file without saving
export const previewEmailUploadApi = (campaignId, file) => {
  return (dispatch) => {
    dispatch({ type: PREVIEW_EMAIL_UPLOAD });

    const formData = new FormData();
    formData.append('file', file);

    axios
      .post(`${config.api.base_url}/email-invites/${campaignId}/preview`, formData, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        dispatch({ type: PREVIEW_EMAIL_UPLOAD_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: PREVIEW_EMAIL_UPLOAD_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Confirm and Send Emails
// SLIM confirm: only the original FILE + this screen's selections travel - the server re-parses
// the file it receives, so a wide file (800+ columns) never round-trips as a giant JSON payload.
export const confirmEmailUploadApi = (campaignId, filename, file, includedDuplicateEmails = [], removedEmails = []) => {
  return (dispatch) => {
    dispatch({ type: CONFIRM_EMAIL_UPLOAD });

    const formData = new FormData();
    formData.append('filename', filename || '');
    formData.append('included_duplicate_emails', JSON.stringify(includedDuplicateEmails || []));
    formData.append('removed_emails', JSON.stringify(removedEmails || []));
    if (file) formData.append('file', file);

    axios
      .post(
        `${config.api.base_url}/email-invites/${campaignId}/confirm`,
        formData,
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((response) => {
        dispatch({ type: CONFIRM_EMAIL_UPLOAD_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: CONFIRM_EMAIL_UPLOAD_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Get Email Invites for a Campaign
export const getEmailInvitesApi = (campaignId, params = {}) => {
  return (dispatch) => {
    dispatch({ type: GET_EMAIL_INVITES });

    axios
      .get(`${config.api.base_url}/email-invites/${campaignId}`, {
        params,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_EMAIL_INVITES_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: GET_EMAIL_INVITES_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Get Email Invite Stats
export const getEmailInviteStatsApi = (campaignId) => {
  return (dispatch) => {
    dispatch({ type: GET_EMAIL_INVITE_STATS });

    axios
      .get(`${config.api.base_url}/email-invites/${campaignId}/stats`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_EMAIL_INVITE_STATS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: GET_EMAIL_INVITE_STATS_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Get Email Batches
// `channel` is optional. Omitted = the study's active channel (previous behaviour, so every
// existing caller is unchanged). Passing 'email' or 'sms' asks for THAT channel's history, which is
// what lets the Uploads modal show both tabs while only one channel is active.
export const getEmailBatchesApi = (campaignId, channel) => {
  return (dispatch) => {
    dispatch({ type: GET_EMAIL_BATCHES });

    axios
      .get(`${config.api.base_url}/email-invites/${campaignId}/batches${channel ? `?channel=${encodeURIComponent(channel)}` : ''}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_EMAIL_BATCHES_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: GET_EMAIL_BATCHES_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Resend Email to Single Respondent
export const resendEmailApi = (respondentId) => {
  return (dispatch) => {
    dispatch({ type: RESEND_EMAIL });

    axios
      .post(
        `${config.api.base_url}/email-invites/${respondentId}/resend`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch({ type: RESEND_EMAIL_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: RESEND_EMAIL_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Resend All Failed Emails
export const resendFailedEmailsApi = (campaignId, batchId = null) => {
  return (dispatch) => {
    dispatch({ type: RESEND_FAILED_EMAILS });

    axios
      .post(
        `${config.api.base_url}/email-invites/${campaignId}/resend-failed`,
        { batchId },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch({ type: RESEND_FAILED_EMAILS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: RESEND_FAILED_EMAILS_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Delete Participant
export const deleteParticipantApi = (respondentId) => {
  return (dispatch) => {
    dispatch({ type: DELETE_PARTICIPANT });

    axios
      .delete(`${config.api.base_url}/email-invites/${respondentId}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: DELETE_PARTICIPANT_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_PARTICIPANT_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};

// Bulk Resend Emails to All Eligible Respondents
export const bulkResendEmailsApi = (campaignId) => {
  return (dispatch) => {
    dispatch({ type: BULK_RESEND_EMAILS });

    axios
      .post(
        `${config.api.base_url}/email-invites/${campaignId}/bulk-resend`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch({ type: BULK_RESEND_EMAILS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({
          type: BULK_RESEND_EMAILS_FAIL,
          response: error.response?.data || error.message,
        });
      });
  };
};
